import gql from 'graphql-tag'

export const GetChillPackCompanies = gql`
	query getChillPackCompanies {
		chillPackCompanyCollection {edges{node{
			id
			name
		}}}
	}
`

export const ExportChillPackRecipients = gql`
	query exportChillPackRecipients {
		export_chill_pack_recipients {
			edges{node{id
			email
			chillpackrecipientclaim
			createdat
			recipientlastname
			recipientfirstname
			companyname}}
		}
	}
`

// MUATTIONS

export const AddChillPackRecipient = gql`
	mutation addChillPackRecipient($data: [ChillPackRecipientInsertInput!]!) {
		insertIntoChillPackRecipientCollection(objects: $data) {
			records{firstName
			lastName
			email
			chillPackCompany {
				id
				name
			}}
		}
	}
`
//todo idk what to do with this two mutaions
export const ResendQRCodeForChillPack = gql`
	mutation resendQRCodeForChillPack($email: String!) {
		resendQRCodeForChillPack(email: $email) {
			code
		}
	}
`
export const ConfirmEmailForChillPackRecipient = gql`
	mutation confirmEmailForChillPackRecipient(
		$chillPackRecipientId: String!
		$pin: String!
	) {
		confirmEmailForChillPackRecipient(
			chillPackRecipientId: $chillPackRecipientId
			pin: $pin
		) {
			id
			firstName
			lastName
			email
		}
	}
`
